import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 380px;
	margin-top: 30px;
`;

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledButtonContainer = styled.div`
	position: absolute;
	bottom: 30px;
	width: calc(100% - 60px);
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	img {
		width: 11px;
	}
`;

export {
	StyledContainer,
	StyledSettingsContainer,
	StyledButtonContainer,
	StyledButtonContent,
};
